import { getQueryStrings } from "./support/browser-hacks";

export interface SetOrUpdateUsersAppParams {
    readonly prompt: string | undefined;
    readonly filesURLs: string | undefined;
}

export function getSetOrUpdateUsersAppParams(): SetOrUpdateUsersAppParams {
    return {
        prompt: getQueryStrings().get("prompt") ?? undefined,
        filesURLs: getQueryStrings().get("files") ?? undefined,
    };
}
